import { useEffect } from "react";
export const useClickOutside = ({ isActive, ref, handler }) => {
    useEffect(() => {
        if (!isActive) {
            return;
        }
        const listener = (event) => {
            event?.stopPropagation();
            if (!ref.current || ref.current?.contains(event.path?.[0] || event.target)) {
                return;
            }
            handler?.(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler, isActive]);
};
export const useClickEscape = ({ isActive, handler }) => {
    useEffect(() => {
        if (!isActive) {
            return;
        }
        const listener = (event) => {
            event?.stopPropagation();
            if (event.key === "Escape" || event.key === "Esc") {
                handler?.(event);
            }
        };
        document.addEventListener("keyup", listener);
        return () => document.removeEventListener("keyup", listener);
    }, [handler, isActive]);
};
